import React from "react";
import styled from "styled-components";
import AbsLogo from "../assets/abs-logo.png";
import TmobAbsLogo from "../assets/vertical_tmo_on_dark_magenta.svg";
import { useConnection } from "../context/ConnectionContext";
import { ConfigurationRenderProps } from "./StrikeZoneRender";

type ContainerProps = {
  height: number;
  width: number;
};

const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => props.width + "px"};
  height: ${(props) => props.height + "px"};
`;

const Img = styled.img`
  width: 50%;
`;

const SHOW_TMOB = process.env.SHOW_TMOB === "true";

const ConnectionTest: React.FC<React.PropsWithChildren<ConfigurationRenderProps>> = ({ children, config }) => {
  const { connected } = useConnection();

  if (connected) {
    return <>{children}</>;
  } else {
    return (
      <Container height={config.scaling.height} width={config.scaling.width}>
        <Img src={SHOW_TMOB ? TmobAbsLogo : AbsLogo} />
      </Container>
    );
  }
};

export default ConnectionTest;
